import { Grid } from "@material-ui/core";
import { useCurrentTenant, useErrorContext } from "@qpr/client-library";
import clsx from "clsx";
import BottomMenuIcon from "qpr-base/viewcomponents/BottomMenuIcon/BottomMenuIcon";
import BottomMenuIconImage from "qpr-base/viewcomponents/BottomMenuIconImage/BottomMenuIconImage";
import BottomNaviTab from "qpr-base/viewcomponents/BottomNaviTabs/BottomNaviTab";
import BottomNaviTabs from "qpr-base/viewcomponents/BottomNaviTabs/BottomNaviTabs";
import Content from "qpr-base/viewcomponents/Content/Content";
import PageContainer from "qpr-base/viewcomponents/PageContainer/PageContainer";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import useNavitems, { Data } from "qpr-base/apihooks/useNavitems";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { checkIfExternal, getFileApiURL } from "qpr-base/utils/url-utils";

const useStyles = (rtl: boolean, model: string) =>
  makeThemedStyles("LandingPageView", (theme) => {
    return {
      mainContainer: {
        width: "100%",
      },
      gridContainer: {},
      contentSection: {
        height: "100%",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
      miscContainer: { width: "100%", alignItems: "end" },
      miscContent: {},
      contentContainer: {
        marginTop: "31.65em",
        marginLeft: "15.54em",
        marginRight: "15.54em",
        color: "rgb(255 255 255)",
      },
      headerContainer: {
        display: "flex",
        maxWidth: "70.17em",
      },
      title: {
        fontFamily: "Dubai",
        fontSize: "4.457em",
        lineHeight: "1.23em",
        fontWeight: 700,
        letterSpacing: "0.01071em",
        color: "rgb(255, 255, 255)",
      },
      subTitle: {
        display: "none",
        fontSize: "2.05em",
        width: "7.88em",
        padding: "0 3.54em",
        paddingTop: "1.82em",
        lineHeight: "1.39em",
        fontWeight: 700,
      },
      quoteContainer: {
        width: "42.5em",
        marginTop: "5.5em",
      },
      quote: {
        fontSize: "2.05em",
      },
      quoteAuthor: {
        fontSize: "1.82em",
        marginTop: "1.25em",
        lineHeight: "2.88em",
        fontFamily: "Dubai",
      },
    };
  });

const LandingPageView = () => {
  const [index, setIndex] = React.useState(0);

  const navi = useHistory();
  const { t } = useTranslation();
  const [sections, setSections] = useState<Data[]>();
  const tenant = useCurrentTenant();
  const tenantSymbol = tenant.symbol;
  const { setError } = useErrorContext();
  const model = useAppContext((m) => m.model);
  const rtl = useAppContext((m) => m.rtl);

  const styles = useStyles(rtl, model || "")();
  const { error, data, isError } = useNavitems();

  useEffect(() => {
    document.title = tenant.symbol.toLocaleUpperCase();
    setSections(data?.children);
  }, [data, tenant.symbol]);

  return (
    <div className={styles.mainContainer}>
      <PageContainer container>
        <Grid item xs={12} className={styles.gridContainer}>
          <Content>
            <div className={styles.contentSection}>
              <div className={styles.contentContainer}>
                <div className={styles.headerContainer}>
                  <span className={clsx(styles.title, "DinNextLTArabic")}>
                    {t("landingPage.title")}
                  </span>
                  <span className={styles.subTitle}>
                    {t("landingPage.welcome")}
                  </span>
                </div>
                <div className={styles.quoteContainer}>
                  <div className={styles.quote}>{t("landingPage.quote")}</div>
                  <div className={styles.quoteAuthor}>
                    {t(`landingPage.author`)}
                  </div>
                </div>
                <div className={styles.miscContainer}>
                  <span className={styles.miscContent}></span>
                </div>
              </div>
            </div>
          </Content>
        </Grid>
      </PageContainer>
      <BottomNaviTabs
        value={index}
        scrollButtons="auto"
        variant="scrollable"
        onChange={(event, newValue) => {
          setIndex(newValue);
        }}
      >
        {sections?.map((section) => {
          if (typeof section.icon === "string") {
            return (
              <BottomNaviTab
                key={section._id}
                disabled={!section.enabled}
                label={t(`navItems.${section.title}`)}
                onClick={() => {
                  if (checkIfExternal(section.link)) {
                    window.open(section.link, "_blank");
                  } else {
                    navi.push(`/${tenantSymbol}${section.link}`);
                  }
                }}
                icon={
                  <BottomMenuIcon>
                    <BottomMenuIconImage
                      src={`${getFileApiURL(section.icon)}`}
                    />
                  </BottomMenuIcon>
                }
              />
            );
          }
          return null;
        })}
      </BottomNaviTabs>
    </div>
  );
};

export default LandingPageView;
